import { gql } from "@apollo/client";











export const GET_ALL_APPROVAL_DETAILS = gql`
  query GetAllApprovalDetails($userId: String, $type: [String]) {
    getAllApprovalDetails(userId: $userId, type: $type) {
      salaryAdvance {
        Id
        userId
        salaryAdvanceAmount
        installmentMonths
        reason
        createdOn
        status
        reportTo
        employeeDetails {
          firstName
          lastName
          imageUrl
        }
        l1Report
        l1Status
        l2Report
        l2Status
        deductionStarts
        payrollStatus
        salaryAdvanceProcess
        totalDeductedAmount
      }
      leaves {
        Id
        employeeId
        leaveType
        startDate
        endDate
        reason
        reportTo
        orgId
        from
        to
        status
        employeeDetails {
          firstName
          lastName
          imageUrl
        }
        totalLeaves
        consumedLeaves
        lop
        reportToDetails {
          firstName
          lastName
        }
        casualLeaveCount
        sickLeaveCount
        earnedLeaveCount
        type
        leaveDuration
        updatedAt
        leavePeriod
        leavescarryForward
        leavetypeId
        usedLeaves
        maxLeaves
        shiftTime
        isBoolean
        uploadDocument
        createdAt
      }
      attendance {
        attendanceId
        usernames {
          firstName
          lastName
          imageUrl
        }
        employeeId
        date
        inTime
        outTime
        from
        to
        limit
        hoursWorked
        reason
        status
        reportTo
        reqinTime
        reqoutTime
        workType
      }
      claims {
        Id
        employeeId
        reason
        location
        description
        typeOfTravel
        typeOfVehicle
        distance
        distanceFrom
        distanceTo
        modeOfTransport
        publicTransportType
        uploadReceipt
        totalAmount
        billDate
        orgId
        status
        isL2Approval
        employeeDetails {
          firstName
          lastName
          imageUrl
        }
        reportTo
        createdAt
        imageUrl
        updatedAt
        isBoolean
        l1approval
        l1reportTo
        l2approval
        l2reportTo
        l2approvalDate
      }
      medicalClaims {
        orgId
        employeeId
        reason
        typeOfMedical
        billNo
        billDate
        patientName
        patientAge
        patientNumber
        location
        description
        uploadReceipt
        totalAmount
        status
        Id
        reportTo
        isL2Approval
        employeeDetails {
          firstName
          lastName
          imageUrl
        }
        createdAt
        imageUrl
        updatedAt
        isBoolean
        l1approval
        l1reportTo
        l2approval
        l2reportTo
      }
      resignations {
        userId
        reasonforResign
        dateofsubmit
        lastworkingDay
        reason
        reportTo
        orgId

        empDetails {
          employeeName
          settledDate
          leaveEncashmentDays
          noticePeriod
          resignationSubmitted
          lastworkingDate
        }
        status
        employeeDetails {
          firstName
          lastName
          imageUrl
        }
        Id
        isBoolean
        approvedBy
        approvedByStatus
        orderBy
        comments
        userDetails {
          firstName
          lastName
        }
        employeeName
      }
    }
  }
`;
